import { ErrorHandler, NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { Event, NavigationError, Router, RouterModule } from '@angular/router';
import { ErrorsComponent } from './errors.component';
import { ErrorsService } from './errors.service';
import { ErrorsHandler } from './errors-handler.service';
import { HttpErrorInterceptor } from './errors-http.interceptor';

@NgModule({
  imports:         [
    CommonModule,
    RouterModule
  ],
  declarations:    [
    ErrorsComponent
  ],
  providers:       [
    ErrorsService,
    {
      provide:  ErrorHandler,
      useClass: ErrorsHandler
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true,
    }
  ]
})
export class ErrorsModule {
  constructor (
    private router: Router,
    private errorService: ErrorsService
  ) {

    // Subscribe to the NavigationError
    this.router
        .events
        .subscribe((event: Event) => {
          if (event instanceof NavigationError) {
            // Redirect to the ErrorComponent
            this.router.navigate(['/error'], {queryParams: this.errorService.addContextInfo(event.error)});
            this.errorService.log(event.error);
          }
        });
  }
}
